import { I18n } from '@app/i18n/strings-keys';
import { ENTITY_ID_PATH } from '@config/index';
import { CELL_FILTER } from '@shared/types/enums/cell-filters.enum';
import { CELL_RENDERER } from '@shared/types/enums/cell-renderer.enum';

export const ENTITY_ID_COLUMN = {
  path: ENTITY_ID_PATH,
  title: I18n.Forms.GridForm.EntityID,
  filterType: CELL_FILTER.string,
  sortable: false,
  cellRenderer: CELL_RENDERER.entity_link_renderer,
};

export const ID_COLUMN = {
  path: '_id',
  title: I18n.Forms.GridForm.ID,
  filterType: CELL_FILTER.string,
  sortable: false,
  cellRenderer: CELL_RENDERER.entity_link_renderer,
};

export const MODIFIED_DATE_COLUMN = {
  path: 'updated_at',
  title: I18n.Forms.GridForm.ModifiedDate,
  sortable: true,
  filterType: CELL_FILTER.dateLocale,
};
